export const MAX_ARTICLES_PER_PAGE = 20;

